import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './FullPageLayout.module.scss';
import logo from '../../../images/cymbio-logo-white.svg';
import LogoutButtonContainer from '../../../containers/menus/LogoutButtonContainer';

function FullPageLayout(props) {
  useEffect(() => {
    const element = document.getElementById('mainContainer');

    if (element) {
      element.classList.add(styles.mainContainer);
    }

    return () => {
      if (element) {
        element.classList.remove(styles.mainContainer);
      }
    };
  });

  return (
    <div className={styles.center}>
      {props.logout && (
        <div className={styles.logoutWrapper}>
          <LogoutButtonContainer />
        </div>
      )}

      <div className={styles.cymbioLogo}>
        <img src={logo} alt="Cymbio Logo" />
      </div>

      <div className={cn(styles.contentWrapper, props.size ? styles[`size-${props.size}`] : '')}>{props.children}</div>
    </div>
  );
}

FullPageLayout.defaultProps = {
  large: false,
  logout: false,
};

FullPageLayout.propTypes = {
  children: PropTypes.element.isRequired,
  large: PropTypes.bool,
  logout: PropTypes.bool,
};

export default FullPageLayout;
